import { MultiSelect } from '@mantine/core';
import React, { useMemo } from 'react';

import { useGetComponents } from 'api/components';

type ComponentSelectorProps = {
  projectId: string;
  orgId: string;
  value: string[];
  onChange: (components: string[]) => void;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
};

export function ComponentSelector({
  projectId,
  orgId,
  value,
  onChange,
  placeholder = 'Select components',
  label = 'Components',
  disabled = false,
}: ComponentSelectorProps) {
  const { data: components = [], isLoading } = useGetComponents(orgId, projectId);

  const componentOptions = useMemo(
    () =>
      components.map((component) => ({
        value: component.name,
        label: component.name,
      })),
    [components]
  );

  return (
    <MultiSelect
      label={label}
      data={componentOptions}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchable
      disabled={disabled || isLoading}
      nothingFound="No components found"
      withinPortal
    />
  );
}
